'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import useBreakpoints from '@/hooks/useBreakpoints';
import { Button } from '@/shared/components/Button';
import { Modal } from '@/utils/antd-imports';
interface VideoWatchNoVideosModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOk: () => void;
}
export const VideoWatchNoVideosModal: FC<VideoWatchNoVideosModalProps> = t0 => {
  const $ = _c(30);
  const {
    isOpen,
    onClose,
    onOk
  } = t0;
  const t = useTranslations("VideoWatch.NoVideos");
  const {
    lg,
    tablet
  } = useBreakpoints();
  if (!isOpen) {
    return null;
  }
  const t1 = lg ? "560px" : tablet ? "400px" : "288px";
  const t2 = lg ? "32px 24px" : tablet ? "28px 24px " : "20px";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      body: {
        display: "flex",
        flexDirection: "column",
        width: t1,
        padding: t2,
        minHeight: "auto",
        background: "#1E1E2A",
        backdropFilter: "blur(36.85px)",
        borderRadius: "24px"
      }
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `absolute ${lg ? "right-[16px] top-[16px]" : "right-[12px] top-[12px]"}  flex items-center justify-center rounded-full border border-[#E9ECF033] p-2 transition-colors hover:bg-white/10`;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image src="/icons/close-default.svg" width={12} height={12} alt="Close" />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== onClose || $[5] !== t4) {
    t6 = <button onClick={onClose} className={t4}>{t5}</button>;
    $[4] = onClose;
    $[5] = t4;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t) {
    t7 = t("new_videos");
    $[7] = t;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = `${t7}`;
  let t9;
  if ($[9] !== t8) {
    t9 = <h2 className="text-center text-[20px] font-bold text-white tablet:text-[28px] lg:text-[36px]"><pre className="font-primary leading-[1.2]">{t8}</pre></h2>;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t) {
    t10 = t("caption");
    $[11] = t;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10) {
    t11 = <div className="flex flex-col items-center gap-3 tablet:gap-4"><span className="text-center text-[16px] font-medium text-[#E9ECF0CC] tablet:text-[20px]">{t10}</span></div>;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t) {
    t12 = t("Ok");
    $[15] = t;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== onOk || $[18] !== t12) {
    t13 = <div className="mt-4  flex w-full flex-col items-center tablet:mt-5"><Button variant="whiteSecondary" size="md_a" className="w-full" onClick={onOk}>{t12}</Button></div>;
    $[17] = onOk;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t11 || $[21] !== t13 || $[22] !== t9) {
    t14 = <div className="flex flex-col  items-center justify-center gap-4 tablet:gap-5">{t9}{t11}{t13}</div>;
    $[20] = t11;
    $[21] = t13;
    $[22] = t9;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== isOpen || $[25] !== onClose || $[26] !== t14 || $[27] !== t3 || $[28] !== t6) {
    t15 = <Modal open={isOpen} onCancel={onClose} footer={null} destroyOnHidden={true} centered={true} className="max-w-[288px] tablet:max-w-[400px] lg:max-w-[560px] [&_.ant-modal-content]:!bg-transparent" styles={t3} closable={false}>{t6}{t14}</Modal>;
    $[24] = isOpen;
    $[25] = onClose;
    $[26] = t14;
    $[27] = t3;
    $[28] = t6;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
};